import { useState } from 'react'

const languageNameToCode = {
  'US English': 'en_us',
  'Australian English': 'en_au',
  'British English': 'en_uk',
  Spanish: 'es',
  French: 'fr',
  German: 'de',
  Italian: 'it',
  Portuguese: 'pt',
  Dutch: 'nl',
  Hindi: 'hi',
  Japanese: 'ja',
  Chinese: 'zh',
  Finnish: 'fi',
  Korean: 'ko',
  Polish: 'pl',
  Russian: 'ru',
  Turkish: 'tr',
  Ukrainian: 'uk',
  Vietnamese: 'vi',
}

export const LanguageSelect = ({
  onSelectChange,
}: {
  onSelectChange: ({
    language_code,
    language,
  }: {
    language_code: string
    language: string
  }) => any
}) => {
  const [language, setLanguage] = useState('English')

  const languages = languageNameToCode

  const handleSelectChange = (event) => {
    const newValue = event.target.value
    setLanguage(newValue)
    onSelectChange({
      language_code: languages[newValue],
      language: newValue,
    })
  }

  return (
    <select
      id="language"
      name="language"
      value={language}
      onChange={handleSelectChange}
      className="block rounded-md border-gray-300 px-4 py-1.5 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
    >
      {Object.keys(languages).map((value) => (
        <option value={value} key={value} className="rounded-md py-1 px-2">
          {value}
        </option>
      ))}
    </select>
  )
}
